import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom, Observable } from 'rxjs';
import { CustomerPortalUrlResponseDto, SubscriptionClientService } from '../core/api';
import { ILogger } from '../interfaces/logger.interface';
import { FeedbackService } from './feedback.service';
import { LocalStorageService } from './local-storage.service';
import { LoggerFactory } from '../utils/logger-factory';

export const REFRESH_SUBSCRIPTION_AFTER_STRIPE_KEY = 'refreshSubscriptionAfterStripe';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPortalService {
  private readonly _subscriptionClient = inject(SubscriptionClientService);
  private readonly _localStorageService = inject(LocalStorageService);
  private readonly _feedbackService = inject(FeedbackService);
  private readonly _translocoService = inject(TranslocoService);
  private readonly _logger: ILogger = LoggerFactory.getLogger('SubscriptionPortalService');

  /** Opens the Stripe customer portal to manage an existing subscription. */
  public async openCustomerPortal(): Promise<void> {
    await this.redirectToUrl(
      this._subscriptionClient.createCustomerPortalUrl(),
      'Failed to create customer portal URL',
      this._translocoService.translate('subscription.messages.portalError', {}, 'settings')
    );
  }

  private async redirectToUrl(request$: Observable<CustomerPortalUrlResponseDto>, logMessage: string, errorMessage: string): Promise<void> {
    try {
      const result = await firstValueFrom(request$);
      if (!result?.url) {
        throw new Error('No portal URL returned');
      }
      this._localStorageService.set(REFRESH_SUBSCRIPTION_AFTER_STRIPE_KEY, '1');
      globalThis.location.href = result.url;
    } catch (error) {
      this._logger.writeError(logMessage, error);
      this._feedbackService.error(errorMessage);
    }
  }
}
